webpackJsonp([10],{

/***/ 723:
/*!*********************************************!*\
  !*** ./src/pages/products/ProductsList.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsList_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductsList.vue */ 856);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcd0654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsList_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1bcd0654","hasScoped":false,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductsList.vue */ 906);
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bcd0654_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 730:
/*!***************************************!*\
  !*** ./src/graphql/MediaFragment.gql ***!
  \***************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Media"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Media"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"alt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":63}};
    doc.loc.source = {"body":"fragment Media on Media {\n  id kind name mime length alt data\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Media"] = oneQuery(doc, "Media");
        


/***/ }),

/***/ 731:
/*!************************************!*\
  !*** ./node_modules/lodash/map.js ***!
  \************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(/*! ./_arrayMap */ 391),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120),
    baseMap = __webpack_require__(/*! ./_baseMap */ 735),
    isArray = __webpack_require__(/*! ./isArray */ 11);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 735:
/*!*****************************************!*\
  !*** ./node_modules/lodash/_baseMap.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ 122),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 773:
/*!******************************************************************!*\
  !*** ./src/pages/collections/graphql/CollectionListFragment.gql ***!
  \******************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CollectionList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Collection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseline"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featured"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":229}};
    doc.loc.source = {"body":"#import \"../../../graphql/MediaFragment.gql\"\n\nfragment CollectionList on Collection {\n  id\n  name\n  published\n  baseline\n  featured\n  createdAt\n  updatedAt\n  categories {\n  \tid name\n  }\n  preview { ...Media }\n  products { id }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CollectionList"] = oneQuery(doc, "CollectionList");
        


/***/ }),

/***/ 774:
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/package-common-vuejs/src/components/table/TableRowActions.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 776:
/*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(/*! ./eq */ 121),
    isArrayLike = __webpack_require__(/*! ./isArrayLike */ 72),
    isIndex = __webpack_require__(/*! ./_isIndex */ 129),
    isObject = __webpack_require__(/*! ./isObject */ 51);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 777:
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/package-common-vuejs/src/components/form/FormInputSearch.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(/*! lodash/debounce */ 782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: String,
    placeholder: { type: String, default: 'Rechercher...' },
    debounce: [Boolean, Number]
  },
  computed: {
    onInputDebounced: function onInputDebounced() {
      return this.debounce ? __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(this.onInput, typeof this.debounce === 'number' ? this.debounce : 750) : this.onInput;
    }
  },
  methods: {
    onInput: function onInput($evt) {
      this.$emit('input', $evt.target.value);
    },
    onChange: function onChange($evt) {
      this.$emit('change', $evt.target.value);
    }
  }
});

/***/ }),

/***/ 778:
/*!********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/package-common-vuejs/src/components/Pagination.vue ***!
  \********************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      offset: { type: Number, default: 0 },
      limit: { type: Number, default: (this.limits || [10])[0] }
    },
    total: { type: [String, Number], default: -1 },
    limits: { type: Array, default: function _default() {
        var base = [10, 25, 50, 100];
        if (this.value && this.value.limit && base.indexOf(this.value.limit) === -1) {
          return [].concat(base, [this.value.limit]).sort();
        }
        return base;
      } },
    fixedLimit: Boolean // Pas de changement possible de la limite
  },
  data: function data() {
    return {
      page: Math.floor(this.value.offset / this.value.limit) || 0,
      perPage: this.value.limit || 10
    };
  },

  computed: {
    totalInt: function totalInt() {
      return Number(this.total);
    },
    totalPages: function totalPages() {
      return this.totalInt >= 0 ? Math.ceil(this.totalInt / this.perPage) - 1 : Infinity;
    }
  },
  updated: function updated() {
    this.perPage = this.value.limit || 10;
    this.page = Math.floor(this.value.offset / this.value.limit) || 0;
  },

  methods: {
    onChange: function onChange() {
      this.$emit('input', {
        offset: this.page * this.perPage,
        limit: this.perPage
      });
      this.$emit('change', {
        offset: this.page * this.perPage,
        limit: this.perPage
      });
    },
    hasPreviousPage: function hasPreviousPage() {
      return this.page > 0;
    },
    hasNextPage: function hasNextPage() {
      return this.totalInt >= 0 && this.page < this.totalPages;
    },
    previousPage: function previousPage() {
      this.page = Math.min(this.totalPages, Math.max(0, this.page - 1));
      this.onChange();
    },
    nextPage: function nextPage() {
      this.page = Math.min(this.totalPages, Math.max(0, this.page + 1));
      this.onChange();
    },
    changedPerPage: function changedPerPage() {
      this.page = 0;
      this.onChange();
    }
  }
});

/***/ }),

/***/ 779:
/*!***************************************************************!*\
  !*** ./src/pages/collections/graphql/CollectionListQuery.gql ***!
  \***************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectionFindAllInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"collectionsFindAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CollectionList"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":244}};
    doc.loc.source = {"body":"#import \"./CollectionListFragment.gql\"\n\nquery($pagination: PaginationInput, $filter: CollectionFindAllInput) {\n  results: collectionsFindAll(pagination: $pagination, filter: $filter) {\n\ttotalCount\n\tedges {\n\t  node { ...CollectionList }\n\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./CollectionListFragment.gql */ 773).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 780:
/*!*************************************!*\
  !*** ./node_modules/lodash/some.js ***!
  \*************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(/*! ./_arraySome */ 407),
    baseIteratee = __webpack_require__(/*! ./_baseIteratee */ 120),
    baseSome = __webpack_require__(/*! ./_baseSome */ 781),
    isArray = __webpack_require__(/*! ./isArray */ 11),
    isIterateeCall = __webpack_require__(/*! ./_isIterateeCall */ 776);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ 781:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseSome.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(/*! ./_baseEach */ 122);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ 782:
/*!*****************************************!*\
  !*** ./node_modules/lodash/debounce.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(/*! ./isObject */ 51),
    now = __webpack_require__(/*! ./now */ 783),
    toNumber = __webpack_require__(/*! ./toNumber */ 784);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 783:
/*!************************************!*\
  !*** ./node_modules/lodash/now.js ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(/*! ./_root */ 15);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 784:
/*!*****************************************!*\
  !*** ./node_modules/lodash/toNumber.js ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(/*! ./_baseTrim */ 785),
    isObject = __webpack_require__(/*! ./isObject */ 51),
    isSymbol = __webpack_require__(/*! ./isSymbol */ 77);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 785:
/*!******************************************!*\
  !*** ./node_modules/lodash/_baseTrim.js ***!
  \******************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(/*! ./_trimmedEndIndex */ 786);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 786:
/*!*************************************************!*\
  !*** ./node_modules/lodash/_trimmedEndIndex.js ***!
  \*************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 787:
/*!************************************************************************************!*\
  !*** ./node_modules/package-common-vuejs/src/components/table/TableRowActions.vue ***!
  \************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_TableRowActions_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../../vue-loader/lib/selector?type=script&index=0!./TableRowActions.vue */ 774);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a16919a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_TableRowActions_vue__ = __webpack_require__(/*! !../../../../vue-loader/lib/template-compiler/index?{"id":"data-v-3a16919a","hasScoped":false,"buble":{"transforms":{}}}!../../../../vue-loader/lib/selector?type=template&index=0!./TableRowActions.vue */ 788);
var normalizeComponent = __webpack_require__(/*! ../../../../vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_TableRowActions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3a16919a_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_TableRowActions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 788:
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a16919a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/package-common-vuejs/src/components/table/TableRowActions.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"icons-list"},[_c('li',{staticClass:"dropdown"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right"},[_vm._t("default")],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle cursor-pointer",attrs:{"data-toggle":"dropdown"}},[_c('i',{staticClass:"icon-menu9"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 789:
/*!************************************************************!*\
  !*** ./src/pages/products/graphql/ProductListFragment.gql ***!
  \************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"preview"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Media"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"combination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"combinationPart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":278}};
    doc.loc.source = {"body":"#import \"../../../graphql/MediaFragment.gql\"\n\nfragment ProductList on Product {\n  id\n  name\n  createdAt\n  updatedAt\n  published\n  kind\n  preview { ...Media }\n  collection { id name }\n  variants { reference }\n  combination { id name parts { id } }\n  combinationPart { id name }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ../../../graphql/MediaFragment.gql */ 730).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductList"] = oneQuery(doc, "ProductList");
        


/***/ }),

/***/ 790:
/*!*****************************!*\
  !*** ./src/common/types.js ***!
  \*****************************/
/*! exports provided: ProductKinds, ProductKindsArray, ProductStandards, ProductStandardsInfos, ProductStandardsArray, ProductPropertyKinds, ProductPropertyKindsArray, ProductPropertySexOptions, ProductPropertySexOptionsArray, ProductDefaultProperties */
/*! exports used: ProductDefaultProperties, ProductKinds, ProductKindsArray, ProductPropertyKindsArray, ProductPropertySexOptions, ProductPropertySexOptionsArray, ProductStandardsArray, ProductStandardsInfos */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductKinds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductKindsArray; });
/* unused harmony export ProductStandards */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ProductStandardsInfos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ProductStandardsArray; });
/* unused harmony export ProductPropertyKinds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProductPropertyKindsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProductPropertySexOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ProductPropertySexOptionsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductDefaultProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/slicedToArray */ 130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);



//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//
// DO NOT FORGET TO CHANGE webapp/src/common/standards.js FILE TOO!
//

var ProductKinds = {
  clothing: "Vêtement",
  linen: "Linges",
  carpet: "Tapis",
  accessory: "Accessoires"
};
var ProductKindsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductKinds, function (label, value) {
  return {
    value: value,
    label: label
  };
});

var ProductStandards = ["ISO 20471-1", "ISO 20471-2", "ISO 20471-3", "ISO 11611-1", "ISO 11611-2", "EN 13034-6", "ISO 11612", "IEC 61482-2", "EN 1149-5", "EN 342", "EN 343", "EN 14058", "EN 14404"].sort(function (a, b) {
  // Clever sort
  var _$exec = /^(\w+)\s*(\d+)/.exec(a),
      _$exec2 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_$exec, 3),
      allA = _$exec2[0],
      nameA = _$exec2[1],
      numberA = _$exec2[2];

  var _$exec3 = /^(\w+)\s*(\d+)/.exec(b),
      _$exec4 = __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_helpers_slicedToArray___default()(_$exec3, 3),
      allB = _$exec4[0],
      nameB = _$exec4[1],
      numberB = _$exec4[2];

  return !!nameA && nameA === nameB ? parseInt(numberA || "0", 10) - parseInt(numberB || "0", 10) : a.localeCompare(b);
});

var ProductStandardsInfos = {
  "ISO 20471-1": {
    name: "ISO 20471-1 - Risque de non visibilité - Classe 1",
    icon: "iso-20471-1",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-1</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 20471-2": {
    name: "ISO 20471-2 - Risque de non visibilité - Classe 2",
    icon: "iso-20471-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 20471-3": {
    name: "ISO 20471-3 - Risque de non visibilité - Classe 3",
    icon: "iso-20471-3",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Visibilit\xE9</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 20471-3</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M1.8,32.5H30v1.8H1.8V32.5z M5.1,6c0.3-0.3,0.6-0.6,1-0.9v19H1.8v-5.4C6.1,13.8,5.4,7.8,5.1,6 M15.9,1.8h0.1\n                c0.6,0,2.6,0.1,4.9,0.8l-5.1,7.5l-5-7.5c2.3-0.7,4.2-0.8,4.8-0.8H15.9z M30,29.6H1.8V27H30V29.6z M22.8,3.3v20.8h-6.1V11.7l5.8-8.6\n                C22.6,3.2,22.7,3.2,22.8,3.3 M9.4,3.1l5.7,8.6v12.4H9V3.3C9.1,3.2,9.3,3.2,9.4,3.1 M30,18.7v5.4h-4.3v-19c0.3,0.3,0.7,0.6,1,0.9\n                C26.4,7.8,25.7,13.8,30,18.7 M31.5,17.7C27,12.8,28.5,6,28.5,6l0.1-0.4l-0.3-0.3C24.1,0.3,17.4,0,16.1,0l-0.1,0l-0.2,0\n                c-1.3,0-8,0.3-12.2,5.2L3.2,5.5L3.3,6c0,0.1,1.6,6.8-3,11.7L0,18v18.1h31.8V18L31.5,17.7z\"/>\n            </g>\n          </svg>"
  },
  "ISO 11611-1": {
    name: "ISO 11611-1 - Risque thermique : chaleur et flammes - Classe 1",
    icon: "iso-11611-1",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Soudage</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11611-1</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M6.6,23.5h16.5c0.1,0,0.2-0.1,0.2-0.2v-2.1c0-0.1-0.1-0.2-0.2-0.2H6.6c-0.1,0-0.2,0.1-0.2,0.2v2.1\n                C6.4,23.4,6.5,23.5,6.6,23.5\"/>\n              <path d=\"M15.4,8.1c0-0.1,0.1-0.2,0.2-0.2h1.9c0.1,0,0.2,0.1,0.2,0.2v1c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.2-0.1-0.2-0.2V8.1z\n                 M14.2,10.8h0.9c0.1,0,0.2,0.1,0.2,0.2l-1,5.6c0,0.1,0.1,0.2,0.2,0.2l1,0.2c0.1,0,0.2,0,0.2-0.2l1-5.8c0-0.1,0.1-0.2,0.2-0.2h7.6\n                c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-5.1c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h5.1c0.1,0,0.2-0.1,0.2-0.2\n                V6.6c0-0.1-0.1-0.2-0.2-0.2H14.2C14,6.4,14,6.5,14,6.6v4C14,10.7,14,10.8,14.2,10.8\"/>\n              <path d=\"M9.1,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C8.2,19.9,8.6,20.2,9.1,20.2\"/>\n              <path d=\"M10.2,17.9c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C9.4,17.6,9.8,17.9,10.2,17.9\"/>\n              <path d=\"M12.4,16.5c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C11.6,16.2,12,16.5,12.4,16.5\"/>\n              <path d=\"M18.1,17.1c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C17.7,17.9,18.1,17.6,18.1,17.1\"/>\n              <path d=\"M18.4,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C17.6,19.9,18,20.2,18.4,20.2\"/>\n            </g>\n          </svg>"
  },
  "ISO 11611-2": {
    name: "ISO 11611-2 - Risque thermique : chaleur et flammes - Classe 2",
    icon: "iso-11611-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Soudage</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11611-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M6.6,23.5h16.5c0.1,0,0.2-0.1,0.2-0.2v-2.1c0-0.1-0.1-0.2-0.2-0.2H6.6c-0.1,0-0.2,0.1-0.2,0.2v2.1\n                C6.4,23.4,6.5,23.5,6.6,23.5\"/>\n              <path d=\"M15.4,8.1c0-0.1,0.1-0.2,0.2-0.2h1.9c0.1,0,0.2,0.1,0.2,0.2v1c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.2-0.1-0.2-0.2V8.1z\n                 M14.2,10.8h0.9c0.1,0,0.2,0.1,0.2,0.2l-1,5.6c0,0.1,0.1,0.2,0.2,0.2l1,0.2c0.1,0,0.2,0,0.2-0.2l1-5.8c0-0.1,0.1-0.2,0.2-0.2h7.6\n                c0.1,0,0.2-0.1,0.2-0.2V9.5c0-0.1-0.1-0.2-0.2-0.2h-5.1c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h5.1c0.1,0,0.2-0.1,0.2-0.2\n                V6.6c0-0.1-0.1-0.2-0.2-0.2H14.2C14,6.4,14,6.5,14,6.6v4C14,10.7,14,10.8,14.2,10.8\"/>\n              <path d=\"M9.1,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C8.2,19.9,8.6,20.2,9.1,20.2\"/>\n              <path d=\"M10.2,17.9c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C9.4,17.6,9.8,17.9,10.2,17.9\"/>\n              <path d=\"M12.4,16.5c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C11.6,16.2,12,16.5,12.4,16.5\"/>\n              <path d=\"M18.1,17.1c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8C17.7,17.9,18.1,17.6,18.1,17.1\"/>\n              <path d=\"M18.4,20.2c0.5,0,0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8c-0.5,0-0.8,0.4-0.8,0.8C17.6,19.9,18,20.2,18.4,20.2\"/>\n            </g>\n          </svg>"
  },
  "EN 13034-6": {
    name: "EN 13034-6 - Risque produits liquides chimiques",
    icon: "en-13034-6",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Produits</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">chimiques</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 13034-6</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M10.1,28h10.6c0.9,0,1.5-0.2,1.8-0.7c0.5-0.7,0.1-1.6,0.1-1.6c0,0-3.2-11-3.9-13.2c-0.6-2.1-0.2-3-0.1-3.1L19.7,7\n                c0.1-0.2,0-0.4-0.2-0.4c-0.2-0.1-0.4,0-0.4,0.2L18,9c-0.1,0.1-0.6,1.1,0.1,3.6c0.2,0.6,0.6,1.9,1,3.5h-7.4c0.5-1.5,0.8-2.8,1-3.5\n                c0.7-2.4,0.2-3.5,0.1-3.5l-1.1-2.4c-0.1-0.2-0.3-0.2-0.4-0.2C11.1,6.6,11,6.8,11.1,7l1.1,2.4c0,0,0.5,0.9-0.2,3\n                c-0.7,2.3-3.9,13.2-3.9,13.2c0,0-0.4,1,0.1,1.7C8.6,27.8,9.2,28,10.1,28\"/>\n              <path d=\"M17.2,5.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                s0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1C23.8,5,23.7,5,23.5,5\n                c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1C22,5,21.9,5,21.7,5c-0.2,0-0.3,0-0.4-0.1\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1C20.2,5,20.1,5,19.9,5c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1\n                c-0.3,0-0.4,0.1-0.5,0.1C18.4,5,18.3,5,18.1,5c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1C17.1,4.8,17,4.9,17,5\n                C17,5.1,17.1,5.2,17.2,5.2\"/>\n              <path d=\"M17.2,4.4c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                s0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1\n                c-0.2,0-0.3,0-0.4-0.1C23,4.1,22.9,4,22.6,4c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1\n                C21.2,4.1,21.1,4,20.8,4c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1C19.4,4.1,19.2,4,19,4\n                c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1C17.6,4.1,17.4,4,17.2,4C17.1,4,17,4.1,17,4.2\n                C17,4.3,17.1,4.4,17.2,4.4\"/>\n              <path d=\"M19.9,3.8c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1\n                c0.3,0,0.4-0.1,0.5-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1\n                c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0,0.2-0.1,0.2-0.2c0-0.1-0.1-0.2-0.2-0.2c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1\n                c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1s-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1\n                c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.2,0.2C19.7,3.7,19.8,3.8,19.9,3.8\"/>\n              <path d=\"M24.4,5.6c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1\n                c-0.3,0-0.4,0.1-0.5,0.1c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.4,0.1-0.5,0.1\n                c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.3,0,0.4-0.1,0.5-0.1C20.5,6,20.6,6,20.8,6\n                c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.3,0.1,0.5,0.1c0.3,0,0.4-0.1,0.5-0.1C22.3,6,22.4,6,22.6,6c0.2,0,0.3,0,0.4,0.1\n                c0.1,0.1,0.3,0.1,0.5,0.1s0.4-0.1,0.5-0.1C24.1,6,24.2,6,24.4,6c0.1,0,0.2-0.1,0.2-0.2C24.6,5.7,24.5,5.6,24.4,5.6\"/>\n            </g>\n          </svg>"
  },
  "ISO 11612": {
    name: "ISO 11612 - Risque soudage chaleurs et projections",
    icon: "iso-11612",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Chaleurs et</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">flammes</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">ISO 11612</text>\n            <g transform=\"translate(9.55 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M10.9,28.3c1.3,0.4,1.5,0,1.5,0c-2.3-1-3-4.2-2-6.7c2.2,2.3,1.9-1.7,1.7-3c1.3,0.5,1.2,4.1,3.3,4.7\n                c-1.4-2.5,0.7-6.8-0.1-8.1c1.6,0.8,1.6,4.1,1.4,5.1c1.4-0.9,0.3-2.7,1.3-4.2c-0.4,1,1.2,3.7,0,5.8c1.2,0.5,1.3-2.1,2.5-1.8\n                c-0.6,0.6,0.2,2.5,0.2,4.5c0,1.6-0.8,3.1-2.2,3.8c0,0,1.1,0.1,1.5,0c2-0.6,3.5-3.2,3.5-5.7c-0.1-3.6-2.2-8.2-1.1-9.5\n                c-1.6-0.1-1.7,2.5-3.1,2.8c0.9-1.6,0.7-3.7-0.4-5.4c-0.7-1.2-0.8-2.8,0-3.5c-1.5,0.4-2.3,3-1.9,5.1c-2-3.1,0.9-6.8-0.5-9\n                c0.4,1.1-1.7,3.4-2.8,5.9c-0.9,2-0.8,5,0.2,7.7c-2.7-2.6-0.4-6.8-2.4-8c1,1.6-2.4,3.4-0.7,7.6c-0.6,0.5-1.1-1.8-2.3-1.3\n                c0.7,0.9-0.5,4.3-0.8,5.8C6.9,24.7,8.4,27.6,10.9,28.3\"/>\n            </g>\n          </svg>"
  },
  "IEC 61482-2": {
    name: "IEC 61482-2 - Risque d'arc électrique",
    icon: "iec-61482-2",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Arc</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">\xE9lectrique</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">IEC 61482-2</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M7.7,16.1l7.8-11.2l7.8,11.2h-5l-2.8-4l-2.8,4H7.7z M7.1,25.5l8.3-12l8.3,12H7.1z M25.4,26.3l-6.5-9.4h6L15.5,3.5L6.1,16.9\n                h6l-6.5,9.4H25.4z\"/>\n            </g>\n          </svg>"
  },
  "EN 1149-5": {
    name: "EN 1149-5 - Risque d'électricité statique",
    icon: "en-1149-5",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 66\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">\xC9lectricit\xE9</text>\n            <text transform=\"translate(25 54)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">statique</text>\n            <text transform=\"translate(25 66)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 1149-5</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n              <path d=\"M7.4,26.5h16.2c0.1,0,0.2-0.1,0.2-0.2v-2c0-0.1-0.1-0.2-0.2-0.2h-7.4l4.9-13.2l-9,5.1l2.7-8.2c0,0,0,0,0.1,0\n                c1,0,1.9-0.8,1.9-1.9c0-1-0.8-1.9-1.9-1.9c-1,0-1.9,0.8-1.9,1.9c0,0.6,0.3,1.1,0.7,1.5l-3.7,11.1l8.8-5l-4,10.7H7.4\n                c-0.1,0-0.2,0.1-0.2,0.2v2C7.2,26.4,7.3,26.5,7.4,26.5\"/>\n            </g>\n          </svg>"
  },
  "EN 342": {
    name: "EN 342 - Risque froid : de -5° jusqu'à -50°C",
    icon: "en-342",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Froid</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 342</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M15.6,22.3l-5.2-3v-5.7l5-2.9l5.2,3v5.8L15.6,22.3z M25,18.7l-0.8-1.4l-2,1.2v-3.9l1.9,1.1l0.8-1.4l-2-1.1l4-2.4l-0.8-1.4\n                l-4,2.3V9.4h-1.6v2.4l-3.5-2L19,8.6l-0.8-1.4l-1.9,1.1V3.8h-1.6v4.6l-2.1-1.2l-0.8,1.4l2,1.2l-3.4,2V9.4H8.8v2.3l-4-2.3L4,10.7\n                l4.1,2.3l-2.2,1.3l0.8,1.4l2.1-1.2v3.9l-2-1.2L6,18.6l2.1,1.2L4,22.2l0.8,1.4l4-2.4v2.2h1.6v-2.3l3.6,2.1l-2.1,1.2l0.8,1.4l1.9-1.1\n                v4.6h1.6v-4.8l2.1,1.2l0.8-1.4l-1.9-1.1l3.4-2v2.2h1.6v-2.1l3.9,2.3l0.8-1.4l-4-2.3L25,18.7z\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  },
  "EN 343": {
    name: "EN 343 - Risque intempéries",
    icon: "en-343",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Intemp\xE9ries</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 343</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n                <path d=\"M15.1,16.9c-0.9,0.1-1.5,0.5-2.1,1.2c-0.6-0.7-1.4-1.2-2.3-1.2c-1,0-1.7,0.5-2.3,1.2c-0.6-0.6-1.2-1.1-2.1-1.2\n                  c-0.9-0.1-1.6,0.2-2.2,0.8c0,0,0,0,0,0c0.1-0.3,0.1-0.5,0.2-0.8c0.4-1.1,1-2.1,1.7-2.9c1.1-1.2,2.4-2.2,4-2.8\n                  c1-0.5,2.1-0.8,3.2-0.9c0.6-0.1,1.2-0.2,1.9-0.2c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c0-0.2,0-0.4,0-0.6c0-0.2,0.1-0.4,0.3-0.4\n                  c0.2,0,0.4,0.1,0.4,0.3c0,0.2,0,0.4,0,0.6c0,0,0,0.1,0,0.1c0.2,0,0.3,0,0.5,0c1.1,0.1,2.2,0.3,3.3,0.6c1.4,0.4,2.6,1,3.8,1.9\n                  c1.1,0.8,1.9,1.7,2.6,2.9c0.4,0.8,0.8,1.8,0.9,2.5c-0.6-0.7-1.4-1.1-2.3-1.1c-0.9,0-1.6,0.5-2.3,1.2c-0.6-0.7-1.4-1.2-2.3-1.2\n                  c-1,0-1.7,0.5-2.3,1.2c-0.5-0.6-1.1-1-1.9-1.1c0,0,0,0.1,0,0.1c0,3.3,0,6.5,0,9.8c0,0.2,0,0.4,0.1,0.6c0.2,0.5,0.5,0.6,1.1,0.6\n                  c0.3,0,0.6-0.2,0.7-0.5c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.4,0.3-0.4c0.2,0,0.4,0.1,0.4,0.3\n                  c0,0.7-0.1,1.4-0.7,1.9c-0.2,0.2-0.4,0.2-0.7,0.3c-0.4,0-0.8,0-1.2-0.2c-0.4-0.2-0.7-0.6-0.8-1.1c-0.1-0.2-0.1-0.4-0.1-0.6\n                  c0-3.3,0-6.5,0-9.8C15.1,17,15.1,17,15.1,16.9z\"/>\n              <path d=\"M18.6,8.7c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1c0.3-0.3,1.5-0.5,1.5-0.5S18.9,8.4,18.6,8.7z\"/>\n              <path d=\"M17.4,6.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S17.7,6.2,17.4,6.4z\"/>\n              <path d=\"M24.4,6.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1S25,4.9,25,4.9S24.7,6.2,24.4,6.4z\"/>\n              <path d=\"M21.2,4.7c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S21.5,4.5,21.2,4.7z\"/>\n              <path d=\"M13.9,7.9c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S14.1,7.7,13.9,7.9z\"/>\n              <path d=\"M21.2,6.7c-0.3,0.3-0.7,0.3-1,0c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,1.5-0.5,1.5-0.5S21.5,6.5,21.2,6.7z\"/>\n              <path d=\"M21.7,9.4c-0.3,0.3-0.7,0.3-1,0s-0.3-0.7,0-1s1.5-0.5,1.5-0.5S22,9.2,21.7,9.4z\"/>\n            </g>\n          </svg>"
  },
  "EN 14058": {
    name: "EN 14058 - Risque frais : au dessus de -5°C",
    icon: "en-14058",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Frais</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 14058</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M15.6,22.3l-5.2-3v-5.7l5-2.9l5.2,3v5.8L15.6,22.3z M25,18.7l-0.8-1.4l-2,1.2v-3.9l1.9,1.1l0.8-1.4l-2-1.1l4-2.4l-0.8-1.4\n                l-4,2.3V9.4h-1.6v2.4l-3.5-2L19,8.6l-0.8-1.4l-1.9,1.1V3.8h-1.6v4.6l-2.1-1.2l-0.8,1.4l2,1.2l-3.4,2V9.4H8.8v2.3l-4-2.3L4,10.7\n                l4.1,2.3l-2.2,1.3l0.8,1.4l2.1-1.2v3.9l-2-1.2L6,18.6l2.1,1.2L4,22.2l0.8,1.4l4-2.4v2.2h1.6v-2.3l3.6,2.1l-2.1,1.2l0.8,1.4l1.9-1.1\n                v4.6h1.6v-4.8l2.1,1.2l0.8-1.4l-1.9-1.1l3.4-2v2.2h1.6v-2.1l3.9,2.3l0.8-1.4l-4-2.3L25,18.7z\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  },
  "EN 14404": {
    name: "EN 14404 - Risque hygroma du genoux",
    icon: "en-14404",
    svg: "<svg version=\"1.1\"\n               xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 50 58\" xml:space=\"preserve\">\n            <text transform=\"translate(25 46)\" text-anchor=\"middle\" style=\"font: 500 9px/9px 'Museo Sans', Helvetica, sans-serif;\">Genoux</text>\n            <text transform=\"translate(25 58)\" text-anchor=\"middle\" style=\"font: 100 9px/9px 'Museo Sans', Helvetica, sans-serif;\">EN 14404</text>\n            <g transform=\"translate(9.1 0)\">\n              <path d=\"M16.2,20.5H7.9v-8.5h3.7c0.2-0.1,0.2-1,0.2-1.5c0-1,0-2.2,0.7-2.9C12.9,7.2,13.3,7,13.9,7h2.3v5.8h9.5V14h-9.5v1.6h9.5v1.1\n                h-9.5V20.5z\"/>\n              <rect x=\"5.2\" y=\"22.3\" width=\"13.2\" height=\"2.3\"/>\n              <path d=\"M29.6,15.8c0,0.5-0.1,12.4-14.1,19c-14-6.6-14.1-18.5-14.1-19V1.3h28.3V15.8z M0,0v15.8c0,0.1,0.1,13.4,15.2,20.4l0.3,0.1\n                l0.3-0.1C30.9,29.2,31,15.9,30.9,15.8V0H0z\"/>\n            </g>\n          </svg>"
  }
};

var ProductStandardsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductStandards, function (value) {
  return {
    value: value,
    label: (ProductStandardsInfos[value] || { name: value }).name
  };
});

var ProductPropertyKinds = {
  tag: "Choix prédéfini",
  sex: "Sexe",
  color: "Couleur",
  text: "Texte libre"
};
var ProductPropertyKindsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductPropertyKinds, function (label, value) {
  return { value: value, label: label };
});

var ProductPropertySexOptions = {
  male: "Homme",
  female: "Femme",
  unisex: "Unisexe"
};
var ProductPropertySexOptionsArray = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(ProductPropertySexOptions, function (label, value) {
  return { value: value, label: label };
});

var ProductDefaultProperties = {
  clothing: [{ name: "Sexe", kind: "sex", required: true },
  //{name: 'Classe', kind: 'tag', required: false},
  //{name: 'Type', kind: 'tag', required: false},
  { name: "Matière", kind: "tag", required: false, tags: ["PC", "CR"] }, { name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Liseré", kind: "color", required: false, colors: [] }, { name: "Parement", kind: "color", required: false, colors: [] }],
  carpet: [{ name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Taille", kind: "tag", required: true }, { name: "Format", kind: "tag", tags: ["Portrait", "Paysage"] }],
  linen: [{ name: "Couleur", kind: "color", required: true, colors: [] }, { name: "Taille", kind: "tag", required: true }, {
    name: "Volant",
    kind: "tag",
    required: false,
    tags: ["Avec volant", "Sans volant"]
  }, { name: "Données techniques", kind: "text", required: false }],
  accessory: []
};

/***/ }),

/***/ 792:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductDetailFragment.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"combination"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"combinationPart"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"required"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"standards"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":259}};
    doc.loc.source = {"body":"#import \"./ProductListFragment.gql\"\n\nfragment ProductDetail on Product {\n  ...ProductList\n  order\n  fullImage\n  combination { id name }\n  combinationPart { id name }\n  properties { id name kind required colors { id name } tags }\n  images { id }\n  standards\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductListFragment.gql */ 789).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductDetail"] = oneQuery(doc, "ProductDetail");
        


/***/ }),

/***/ 793:
/*!***********************************************************************************!*\
  !*** ./node_modules/package-common-vuejs/src/components/form/FormInputSearch.vue ***!
  \***********************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_FormInputSearch_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../../vue-loader/lib/selector?type=script&index=0!./FormInputSearch.vue */ 777);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_282d4c13_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_FormInputSearch_vue__ = __webpack_require__(/*! !../../../../vue-loader/lib/template-compiler/index?{"id":"data-v-282d4c13","hasScoped":false,"buble":{"transforms":{}}}!../../../../vue-loader/lib/selector?type=template&index=0!./FormInputSearch.vue */ 794);
var normalizeComponent = __webpack_require__(/*! ../../../../vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_FormInputSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_282d4c13_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_FormInputSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 794:
/*!************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282d4c13","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/package-common-vuejs/src/components/form/FormInputSearch.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group has-feedback"},[_c('input',_vm._b({staticClass:"form-control",attrs:{"type":"search","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.onInputDebounced,"change":_vm.onChange}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control-feedback"},[_c('i',{staticClass:"icon-search4 text-size-base text-muted"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 795:
/*!*************************************************************************!*\
  !*** ./node_modules/package-common-vuejs/src/components/Pagination.vue ***!
  \*************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!../../../vue-loader/lib/selector?type=script&index=0!./Pagination.vue */ 778);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fba8c22e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(/*! !../../../vue-loader/lib/template-compiler/index?{"id":"data-v-fba8c22e","hasScoped":false,"buble":{"transforms":{}}}!../../../vue-loader/lib/selector?type=template&index=0!./Pagination.vue */ 796);
var normalizeComponent = __webpack_require__(/*! ../../../vue-loader/lib/component-normalizer */ 2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_usr_src_apps_admin_package_json_cacheDirectory_true_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fba8c22e_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 796:
/*!**************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fba8c22e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/package-common-vuejs/src/components/Pagination.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-elements"},[_c('span',{staticClass:"heading-text text-semibold"},[_vm._v("Résultats "+_vm._s(Math.min(_vm.totalInt, 1 + _vm.page * _vm.perPage))+"\n\t\t\t\t\t\tà "+_vm._s(Math.min(_vm.totalInt >= 0? _vm.totalInt: Infinity, (_vm.page + 1) * _vm.perPage))+"\n\t\t\t\t\t\t"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!(_vm.totalInt < 0)),expression:"!(totalInt < 0)"}]},[_vm._v("sur "+_vm._s(_vm.totalInt))])]),_vm._v(" "),_c('ul',{staticClass:"pager pager-xs pull-right"},[_c('li',{class:{disabled: !_vm.hasPreviousPage()}},[_c('a',{attrs:{"disabled":!_vm.hasPreviousPage()},on:{"click":_vm.previousPage}},[_vm._v("← Précédent")])]),_vm._v(" "),_c('li',{class:{disabled: !_vm.hasNextPage()}},[_c('a',{attrs:{"disabled":!_vm.hasNextPage()},on:{"click":_vm.nextPage}},[_vm._v("Suivant →")])])]),_vm._v(" "),(!_vm.fixedLimit)?_c('form',{staticClass:"heading-form pull-right hidden-xs"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-xs",staticStyle:{"width":"10em"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.changedPerPage]}},_vm._l((_vm.limits),function(value){return _c('option',{key:value,domProps:{"value":value}},[_vm._v(_vm._s(value)+" par page")])}),0)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 806:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductUpdateMutation.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductDetail"},"directives":[]}]}}]}}],"loc":{"start":0,"end":148}};
    doc.loc.source = {"body":"#import \"./ProductDetailFragment.gql\"\n\nmutation($id: ID!, $data: ProductInput) {\n  productUpdate(id: $id, data: $data) {\n    ...ProductDetail\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductDetailFragment.gql */ 792).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 828:
/*!**************************************************************!*\
  !*** ./src/pages/products/graphql/ProductRemoveMutation.gql ***!
  \**************************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"result"},"name":{"kind":"Name","value":"productRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[]}]}}],"loc":{"start":0,"end":55}};
    doc.loc.source = {"body":"mutation($id: ID!) {\n  result: productRemove(id: $id)\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 856:
/*!****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":"/usr/src/apps/admin/package.json","cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/products/ProductsList.vue ***!
  \****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/asyncToGenerator */ 75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(/*! ./node_modules/babel-runtime/helpers/extends */ 38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(/*! vuex */ 410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(/*! lodash/filter */ 420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(/*! lodash/map */ 731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_some__ = __webpack_require__(/*! lodash/some */ 780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_package_common_vuejs_src_components_form_FormInputSearch__ = __webpack_require__(/*! package-common-vuejs/src/components/form/FormInputSearch */ 793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_package_common_vuejs_src_components_Pagination__ = __webpack_require__(/*! package-common-vuejs/src/components/Pagination */ 795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_package_common_vuejs_src_components_table_TableRowActions__ = __webpack_require__(/*! package-common-vuejs/src/components/table/TableRowActions */ 787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_MediaImage__ = __webpack_require__(/*! ../../components/MediaImage */ 409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_PublishingStatus__ = __webpack_require__(/*! ../../components/PublishingStatus */ 411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Activity__ = __webpack_require__(/*! ../../components/Activity */ 416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_ProductListQuery_gql__ = __webpack_require__(/*! ./graphql/ProductListQuery.gql */ 905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphql_ProductListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__graphql_ProductListQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_ProductRemoveMutation_gql__ = __webpack_require__(/*! ./graphql/ProductRemoveMutation.gql */ 828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__graphql_ProductRemoveMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__graphql_ProductRemoveMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_graphql_CollectionListQuery_gql__ = __webpack_require__(/*! ../collections/graphql/CollectionListQuery.gql */ 779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_graphql_CollectionListQuery_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__collections_graphql_CollectionListQuery_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_ProductUpdateMutation_gql__ = __webpack_require__(/*! ./graphql/ProductUpdateMutation.gql */ 806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__graphql_ProductUpdateMutation_gql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__graphql_ProductUpdateMutation_gql__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_types__ = __webpack_require__(/*! ../../common/types */ 790);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















function hashCode() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var hash = 0,
      i = void 0,
      chr = void 0;
  if (string.length === 0) return hash;
  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MediaImage: __WEBPACK_IMPORTED_MODULE_10__components_MediaImage__["default"],
    FormInputSearch: __WEBPACK_IMPORTED_MODULE_7_package_common_vuejs_src_components_form_FormInputSearch__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_8_package_common_vuejs_src_components_Pagination__["a" /* default */],
    TableRowActions: __WEBPACK_IMPORTED_MODULE_9_package_common_vuejs_src_components_table_TableRowActions__["a" /* default */],
    PublishingStatus: __WEBPACK_IMPORTED_MODULE_11__components_PublishingStatus__["default"],
    Activity: __WEBPACK_IMPORTED_MODULE_12__components_Activity__["default"]
  },
  data: function data() {
    return {
      results: {
        totalCount: 0,
        edges: []
      },
      collections: [],

      ProductKinds: __WEBPACK_IMPORTED_MODULE_17__common_types__["c" /* ProductKindsArray */]
    };
  },

  apollo: {
    results: {
      query: __WEBPACK_IMPORTED_MODULE_13__graphql_ProductListQuery_gql___default.a,
      fetchPolicy: "network-only",
      variables: function variables() {
        return {
          pagination: {
            after: this.pagination.offset,
            limit: this.pagination.limit
          },
          filter: __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, this.filter)
        };
      }
    },
    collections: {
      query: __WEBPACK_IMPORTED_MODULE_15__collections_graphql_CollectionListQuery_gql___default.a,
      fetchPolicy: "network-only",
      variables: function variables() {
        return {
          pagination: {
            limit: 999
          }
        };
      },

      update: function update(data) {
        return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(data.results.edges, function (_ref) {
          var _ref$node = _ref.node,
              id = _ref$node.id,
              name = _ref$node.name;
          return {
            value: id,
            label: name
          };
        });
      }
    }
  },
  computed: {
    products: function products() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.results.edges, "node");
    },
    filter: function filter() {
      return this.$store.state.products.filter;
    },

    pagination: {
      get: function get() {
        return this.$store.state.products.pagination;
      },
      set: function set(value) {
        this.setPagination(value);
      }
    },
    isFiltered: function isFiltered() {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_some___default()(this.filter);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$apollo.queries.results.refetch();
    });
  },
  beforeMount: function beforeMount() {
    var _ref2 = this.$route.query || {},
        _ref2$collection = _ref2.collection,
        collection = _ref2$collection === undefined ? null : _ref2$collection;

    if (collection) {
      this.setFilterCollection(collection);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_2__usr_src_apps_admin_node_modules_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])("products", ["setFilterSearch", "setFilterKind", "setFilterCollection", "setPagination", "resetFilter"]), {
    getName: function getName(_ref3) {
      var name = _ref3.name,
          combination = _ref3.combination,
          combinationPart = _ref3.combinationPart;

      return __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()([combination && combination.name, combination && combination.parts && combination.parts.length > 1 && combinationPart && combinationPart.name, name]).join(" / ");
    },
    getKindName: function getKindName(_ref4) {
      var kind = _ref4.kind;

      return __WEBPACK_IMPORTED_MODULE_17__common_types__["b" /* ProductKinds */][kind];
    },
    getCollectionName: function getCollectionName(_ref5) {
      var collection = _ref5.collection;

      return collection && collection.name;
    },
    getCollectionStyle: function getCollectionStyle(_ref6) {
      var collection = _ref6.collection;

      var hash = hashCode(collection && collection.name || '');
      return "background: hsl(" + hash % 360 + ", 30%, 50%); border-color: hsl(" + hash % 360 + ", 20%, 45%);";
    },
    setProductPublished: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(product) {
        var published = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_16__graphql_ProductUpdateMutation_gql___default.a,
                  variables: {
                    id: product.id,
                    data: { published: published }
                  }
                });

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                this.$store.dispatch("addNotificationError", _context.t0.message);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function setProductPublished(_x3) {
        return _ref7.apply(this, arguments);
      }

      return setProductPublished;
    }(),
    deleteProduct: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1__usr_src_apps_admin_node_modules_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(product) {
        var _ref9, data;

        return __WEBPACK_IMPORTED_MODULE_0__usr_src_apps_admin_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.$apollo.mutate({
                  mutation: __WEBPACK_IMPORTED_MODULE_14__graphql_ProductRemoveMutation_gql___default.a,
                  variables: {
                    id: product.id
                  }
                });

              case 3:
                _ref9 = _context2.sent;
                data = _ref9.data;

                if (data.result) {
                  this.$store.dispatch("addNotificationSuccess", "Le produit a \xE9t\xE9 supprim\xE9");
                  this.$apollo.queries.results.refetch();
                } else {
                  this.$store.dispatch("addNotificationError", "Le produit n'a pas pu \xEAtre supprim\xE9");
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                this.$store.dispatch("addNotificationError", _context2.t0.message);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function deleteProduct(_x4) {
        return _ref8.apply(this, arguments);
      }

      return deleteProduct;
    }()
  })
});

/***/ }),

/***/ 905:
/*!*********************************************************!*\
  !*** ./src/pages/products/graphql/ProductListQuery.gql ***!
  \*********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductFindAllInput"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"results"},"name":{"kind":"Name","value":"productsFindAll"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductList"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":232}};
    doc.loc.source = {"body":"#import \"./ProductListFragment.gql\"\n\nquery($pagination: PaginationInput, $filter: ProductFindAllInput) {\n  results: productsFindAll(pagination: $pagination, filter: $filter) {\n\ttotalCount\n\tedges {\n\t  node { ...ProductList }\n\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(__webpack_require__(/*! ./ProductListFragment.gql */ 789).definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    


/***/ }),

/***/ 906:
/*!**********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bcd0654","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/products/ProductsList.vue ***!
  \**********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"light":""}},[_c('h5',{staticClass:"panel-title",attrs:{"slot":"heading"},slot:"heading"},[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),_c('div',{staticClass:"heading-elements",attrs:{"slot":"heading"},slot:"heading"},[_c('div',{staticClass:"heading-buttons"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{name: 'product/create', query: _vm.filter}}},[_vm._v("Ajouter un produit")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-inline",attrs:{"slot":"body"},slot:"body"},[_c('form-group',[_c('form-input-search',{attrs:{"value":_vm.filter.search,"debounce":""},on:{"input":_vm.setFilterSearch}})],1),_vm._v(" "),_c('form-group',[_c('form-select',{attrs:{"value":_vm.filter.kind,"options":_vm.ProductKinds,"placeholder":"Filtrer par type"},on:{"input":_vm.setFilterKind}})],1),_vm._v(" "),_c('form-group',[_c('form-select',{attrs:{"value":_vm.filter.collection,"options":_vm.collections,"placeholder":"Filtrer par collection"},on:{"input":_vm.setFilterCollection}})],1),_vm._v(" "),_c('form-group',[(_vm.isFiltered)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.resetFilter()}}},[_vm._v("Effacer les filtres")]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"table-responsive",attrs:{"slot":"content"},slot:"content"},[_c('table',{staticClass:"table table-striped table-lg"},[_c('thead',[_c('tr',[_c('th',{attrs:{"width":"135"}},[_vm._v("Aperçu")]),_vm._v(" "),_c('th',[_vm._v("Nom du produit")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Déclinaisons")]),_vm._v(" "),_c('th',[_vm._v("Activité")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"100"}},[_vm._v("Statut")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"80"}},[_vm._v("Actions")])])]),_vm._v(" "),(_vm.products.length)?_c('tbody',_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',{staticClass:"centered"},[_c('media-image',{attrs:{"media":product.preview,"empty-label":"Pas d'image","thumbnail":""}})],1),_vm._v(" "),_c('td',[_c('span',{staticClass:"label label-default",style:(_vm.getCollectionStyle(product))},[_vm._v(_vm._s(_vm.getCollectionName(product)))]),_vm._v(" "),_c('h6',{staticClass:"no-margin text-semibold"},[_c('router-link',{attrs:{"to":{name: 'product/edit', params: {id: product.id}}}},[_vm._v(_vm._s(_vm.getName(product)))])],1)]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_vm._v("\n          "+_vm._s(_vm.getKindName(product))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_c('router-link',{attrs:{"to":{name: 'product/variants', params: {id: product.id}}}},[_vm._v(_vm._s(product.variants.length)+" déclinaison(s)")])],1),_vm._v(" "),_c('td',{staticClass:"text-nowrap"},[_c('activity',{attrs:{"value":product}})],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('publishing-status',{staticClass:"cursor-pointer",attrs:{"value":product.published},on:{"hide":function($event){return _vm.setProductPublished(product, false)},"show":function($event){return _vm.setProductPublished(product)}}})],1),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c("table-row-actions",{tag:"ul"},[_c('li',[_c('router-link',{attrs:{"to":{name: 'product/edit', params: {id: product.id}}}},[_c('i',{staticClass:"icon-pencil7"}),_vm._v(" Modifier")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'product/variants', params: {id: product.id}}}},[_c('i',{staticClass:"icon-color-sampler"}),_vm._v(" Gérer les déclinaisons")])],1),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.deleteProduct(product)}}},[_c('i',{staticClass:"icon-bin"}),_vm._v(" Supprimer")])])])],1)])}),0):(_vm.$apollo.loading)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('h4',[_vm._v("Chargement…")])])])]):_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('h4',[_vm._v("Aucun résultat")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{name: 'product/create', query: _vm.filter}}},[_vm._v("Ajouter un produit")])],1)])])])]),_vm._v(" "),_c('pagination',{attrs:{"slot":"footer","total":_vm.results.totalCount},slot:"footer",model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// 10.e2f1c9e3.chunk.js